import BaseEvent, { BaseGetEvent, IBaseEvent } from './BaseEvent';

export interface IFileSelectEvent extends IBaseEvent {
  type: 'file';
  toJSON(): BaseGetEvent & {
    type: IFileSelectEvent['type'];
  };
}

export default class FileSelectEvent
  extends BaseEvent
  implements IFileSelectEvent
{
  type = 'file' as const;

  constructor({ description }: { description: string }) {
    super(description);
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
    };
  }
}
